import Model from '@/models/ExtendModel'

export default class WhWarehouse extends Model {
    resource() {
        return 'wh_warehouse'
    }
}